export default __webpack_public_path__ + "static/media/logo5.5cf47b9b.svg";